const helpMenuStyles = {
  overflowLabelOverrideStyle: {
    'button#help-overflow-menu > :nth-child(1)': { display: 'none' },
    'button#help-overflow-menu > :nth-child(2)': { clipPath: 'none', position: 'relative' },
    '> ul': {
      marginTop: '15px',
      zIndex: '99',
    },
  },
  modalStyle: {
    width: '300px',
    maxHeight: '640px',
    position: 'unset',
    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.5)',
    '> div:first-of-type': {
      padding: '0',
      outline: 'none !important',
      outlineOffset: '0px !important',
    },
  },
  modalBodyStyle: {
    maxHeight: '584px',
    overflowY: 'scroll',
  },
};

export default helpMenuStyles;
